import Banner from "@puregym/gatsby-plugin-banner";
import { useMediaQuery } from "@puregym/react-hooks";
import { useTheme } from "@puregym/ui";
import { getDeviceInfo } from "@puregym/utilities";
import { graphql } from "gatsby";
import GymSeoHead from "../../components/common/gymSeoHead";
import PrimaryPanel from "../../components/gymIndexPage/primaryPanel";
import Map, { GlobalSearchPageStyles } from "../../components/map";
import { GymSearchGrid, StyledPageMainSearch } from "../../styles/Layout";
import { useGymSearchState } from "../../context";

export const Head = ({ data }) => {
  const { seoTitle, seoDescription } = data.gymMiscData;
  return <GymSeoHead title={seoTitle} description={seoDescription} />;
};

/**
 * App index page (Gym Search).
 *
 * If the screen is large enough, show both map + list.
 * For mobile displays, we let you toggle between them.
 *
 * @see https://www.gatsbyjs.com/docs/creating-and-modifying-pages/
 */
const Index = ({ data }) => {
  const { mediaQueries } = useTheme();
  const showSecondaryPanel = useMediaQuery(mediaQueries.md, {
    defaultMatches: true,
  });
  const { isBrowser } = getDeviceInfo();
  const { gyms } = useGymSearchState();

  /**
   * For SSR (and SEO) the gym list must be rendered. In the
   * browser, we set the default mobile view to the map.
   */
  const defaultGymDisplay = () => {
    if (!isBrowser) {
      return "list";
    }
    return showSecondaryPanel ? "list" : "map";
  };

  return (
    <>
      <Banner
        anonymousBanner={data?.straplineBanners?.anonymous}
        authenticatedBanner={data?.straplineBanners?.authenticated}
        studentBanner={data?.straplineBanners?.student}
      />
      <StyledPageMainSearch as="main" id="main-content" fullWidth>
        <GlobalSearchPageStyles />
        <GymSearchGrid>
          <PrimaryPanel defaultGymDisplayType={defaultGymDisplay()} gyms={gyms} />
          {showSecondaryPanel && <Map gyms={gyms} testid="gymMap" />}
        </GymSearchGrid>
      </StyledPageMainSearch>
    </>
  );
};

export const query = graphql`
  {
    gymMiscData {
      seoTitle
      seoDescription
    }
    straplineBanners {
      anonymous {
        ...StraplineBanner
      }
      authenticated {
        ...StraplineBanner
      }
      student {
        ...StraplineBanner
      }
    }
  }
`;

export default Index;
